import { defineComponent as _defineComponent } from 'vue'
import { toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, createElementVNode as _createElementVNode, unref as _unref, vModelText as _vModelText, withDirectives as _withDirectives, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createBlock as _createBlock, vModelSelect as _vModelSelect, renderList as _renderList, Fragment as _Fragment, vModelCheckbox as _vModelCheckbox, withModifiers as _withModifiers } from "vue"

const _hoisted_1 = { key: 0 }
const _hoisted_2 = { class: "form-field" }
const _hoisted_3 = /*#__PURE__*/_createElementVNode("label", null, "Select move out date", -1)
const _hoisted_4 = ["disabled"]
const _hoisted_5 = /*#__PURE__*/_createElementVNode("button", { class: "btn" }, "Cancel", -1)
const _hoisted_6 = ["onSubmit"]
const _hoisted_7 = /*#__PURE__*/_createTextVNode(" A move-out dated today is completed now rather than scheduled. Confirm below to finish it, or go back and choose a later date to schedule it. ")
const _hoisted_8 = { class: "form-field" }
const _hoisted_9 = /*#__PURE__*/_createElementVNode("label", null, " Unit Status", -1)
const _hoisted_10 = /*#__PURE__*/_createElementVNode("option", { value: true }, "Rentable", -1)
const _hoisted_11 = /*#__PURE__*/_createElementVNode("option", { value: false }, "Unrentable", -1)
const _hoisted_12 = [
  _hoisted_10,
  _hoisted_11
]
const _hoisted_13 = { class: "form-field" }
const _hoisted_14 = /*#__PURE__*/_createElementVNode("label", null, "Payment Method", -1)
const _hoisted_15 = ["value"]
const _hoisted_16 = { class: "form-field" }
const _hoisted_17 = /*#__PURE__*/_createElementVNode("label", null, "Refund Check Name", -1)
const _hoisted_18 = { class: "form-field" }
const _hoisted_19 = /*#__PURE__*/_createElementVNode("label", { for: "address_line_1" }, "Address line 1:", -1)
const _hoisted_20 = { class: "form-field" }
const _hoisted_21 = /*#__PURE__*/_createElementVNode("label", { for: "address_line_2" }, "Address line 2:", -1)
const _hoisted_22 = { class: "form-field" }
const _hoisted_23 = /*#__PURE__*/_createElementVNode("label", { for: "city" }, "City:", -1)
const _hoisted_24 = { class: "form-field" }
const _hoisted_25 = /*#__PURE__*/_createElementVNode("label", { for: "state" }, "State/Province:", -1)
const _hoisted_26 = { class: "form-field" }
const _hoisted_27 = /*#__PURE__*/_createElementVNode("label", { for: "postal" }, "Postal:", -1)
const _hoisted_28 = { class: "form-field" }
const _hoisted_29 = /*#__PURE__*/_createElementVNode("label", { for: "postal" }, "Country:", -1)
const _hoisted_30 = { class: "form-field" }
const _hoisted_31 = /*#__PURE__*/_createElementVNode("label", null, "Refund security Deposit", -1)
const _hoisted_32 = { class: "form-field" }
const _hoisted_33 = /*#__PURE__*/_createElementVNode("label", null, "Refund prepayment", -1)
const _hoisted_34 = { style: {"text-align":"center"} }
const _hoisted_35 = ["disabled"]
const _hoisted_36 = {
  key: 0,
  class: "col"
}
const _hoisted_37 = /*#__PURE__*/_createTextVNode(" Finalizing Move Out ")
const _hoisted_38 = {
  key: 1,
  class: "col"
}
const _hoisted_39 = /*#__PURE__*/_createTextVNode("Finalize Later")

import moment from "moment";

// import { useRouter } from "vue-router";
import { ref, watch } from "vue";
import { useRouter, useRoute } from "vue-router";

import api from "@virgodev/bazaar/functions/api";
// const router = useRouter();
import BaseSpinner from "@/components/BaseSpinner.vue";
import { useStore } from "../../store";
import { storeToRefs } from "pinia";
import { paymentAccountInterface } from "@/types/customers";

export default /*#__PURE__*/_defineComponent({
  props: {
  customerId: {
    type: Number,
    required: true,
  },
  rentalId: {
    type: Number,
    required: true,
  },
  customerName: {
    type: String,
    required: true,
  },
  unitName: {
    type: String,
    required: true,
  },
  unitsLeft: {
    type: Number,
    required: true,
  },
  edit: {
    type: Number,
    required: true,
  },
  facilityId: {
    type: String,
    default: null,
  },
  scheduledId: {
    type: String,
    default: null,
  },
  unitTypeId: {
    type: String,
    default: null,
  },
  ledgerId: {
    type: String,
    default: null,
  },
},
  setup(__props) {

const props = __props

const formErrors = ref<Record<string, string[]>>({});
const formSubmitting = ref(false);
const store = useStore();
const { userData } = storeToRefs(store);
const api_settings = userData.value.chosenFacility.api_settings;
const router = useRouter();
const route = useRoute();
const errors = ref("");
const finalize = ref(false);
// Set when the agent asked to schedule but picked today, so the finalize form
// can say why it is showing.
const finalizingToday = ref(false);
const paymentMethod = ref();

const paymentAccounts = ref(Array<paymentAccountInterface>());
const formFields = ref({
  move_out: {
    unit_id: ref(props.rentalId),
    tenant_id: ref(props.customerId),
    desired_move_out_date: ref(),
    refund_security_deposit: ref(false),
    refund_prepayment: ref(false),
  },
  payment_method: {
    payment_method_id: ref(),
  },
  refund: {
    refund_check_name: "",
    refund_check_address_attributes: {
      address1: "",
      address2: "",
      city: "",
      state: "",
      postal: "",
      country: "",
    },
  },
});
watch(paymentMethod, () => {
  formFields.value.refund.refund_check_address_attributes.address1 =
    paymentMethod.value.billing_address.address1;
  formFields.value.refund.refund_check_address_attributes.address2 =
    paymentMethod.value.billing_address.address2;
  formFields.value.refund.refund_check_address_attributes.city =
    paymentMethod.value.billing_address.city;
  formFields.value.refund.refund_check_address_attributes.state =
    paymentMethod.value.billing_address.state;
  formFields.value.refund.refund_check_address_attributes.postal =
    paymentMethod.value.billing_address.postal;
  formFields.value.refund.refund_check_address_attributes.country =
    paymentMethod.value.billing_address.country;
});
const formFieldsStatus = ref({
  unit: {
    rentable: ref(true),
  },
});

formFields.value.move_out.desired_move_out_date = ref(
  moment().format("YYYY-MM-DD")
);
if (props.scheduledId) {
  finalize.value = true;
}
async function getPaymentAccounts() {
  errors.value = "";
  const response = await api({
    url: `payment_accounts/?id=${props.customerId}&facilityId=${props.facilityId}`,
  });
  if (response.status == 200) {
    paymentAccounts.value = response.body;
  } else {
    errors.value =
      "Unable to communicate with the server. Please check your " +
      "connection and try again.";
  }
}
async function scheduleMoveOut() {
  if (
    formFields.value.move_out.desired_move_out_date ==
    moment().format("YYYY-MM-DD")
  ) {
    finalizingToday.value = true;
    finalize.value = true;
  } else {
    let json;
    if (api_settings.ledger_id_with_schedule_move_out) {
      json = JSON.parse(
        JSON.stringify({
          move_out: {
            ledger_id: props.ledgerId,
            desired_move_out_date:
              formFields.value.move_out.desired_move_out_date,
          },
        })
      );
    } else {
      json = JSON.parse(
        JSON.stringify({
          move_out: {
            unit_id: props.rentalId,
            tenant_id: props.customerId,
            desired_move_out_date:
              formFields.value.move_out.desired_move_out_date,
          },
        })
      );
    }

    formErrors.value = {};
    formSubmitting.value = true;
    let url = `schedule_move_out/?facilityId=${props.facilityId}&ledger_id=${props.ledgerId}`;
    const responseData = await api({
      url,
      method: "POST",
      json,
    });

    if ([200, 201].includes(responseData.status)) {
      if (
        formFields.value.move_out.desired_move_out_date ==
        moment().format("YYYY-MM-DD")
      ) {
        finalize.value = true;
      } else {
        router.push(
          typeof route.query.next === "string"
            ? route.query.next
            : {
                name: "customer_detail_storedge",
                params: {
                  id: props.customerId,
                  facilityId: props.facilityId,
                },
              }
        );
      }
    } else if (responseData.status == 400) {
      if (responseData.body.error) {
        formErrors.value.server_error = [responseData.body.error];
      }
    } else {
      formErrors.value = {
        non_field_errors: [
          "Unable to communicate with the server. Please check your " +
            "connection and try again.",
        ],
      };
    }
  }
}
async function updateUnitStatus() {
  const json = JSON.parse(JSON.stringify(formFieldsStatus.value));
  formErrors.value = {};
  formSubmitting.value = true;
  let url = `unit_status/?id=${props.rentalId}&facilityId=${props.facilityId}`;

  const responseData = await api({
    url,
    method: "PATCH",
    json,
  });

  formSubmitting.value = false;

  if (responseData.status === 200) {
    router.push(
      typeof route.query.next === "string"
        ? route.query.next
        : {
            name: "customer_detail_storedge",
            params: {
              id: props.customerId,
              facilityId: props.facilityId,
            },
          }
    );
  } else if (responseData.status === 400) {
    formErrors.value = responseData.body;
  } else {
    formErrors.value = {
      non_field_errors: [
        "Unable to communicate with the server. Please check your " +
          "connection and try again.",
      ],
    };
  }
}

async function submitForm() {
  formFields.value.move_out.desired_move_out_date =
    moment().format("YYYY-MM-DD");
  const json = JSON.parse(JSON.stringify(formFields.value));
  if (!json.payment_method.payment_method_id) {
    delete json.payment_method;
    delete json.refund;
  }
  let url = `finalize_move_out/?facilityId=${props.facilityId}&ledger_id=${props.ledgerId}`;

  formErrors.value = {};
  formSubmitting.value = true;
  const responseData = await api({
    url,
    method: "POST",
    json,
  });

  if ([200, 201].includes(responseData.status)) {
    await updateUnitStatus();
  } else if (responseData.status === 400) {
    formErrors.value = { server_error: [responseData.body.meta.message] };
  } else {
    formErrors.value = {
      non_field_errors: [
        "Unable to communicate with the server. Please check your " +
          "connection and try again.",
      ],
    };
  }
}

getPaymentAccounts();

return (_ctx: any,_cache: any) => {
  const _component_RouterLink = _resolveComponent("RouterLink")!
  const _component_BaseAlert = _resolveComponent("BaseAlert")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createVNode(_component_RouterLink, {
      to: {
      name: 'customer_detail_storedge',
      params: { id: __props.customerId, facilityId: __props.facilityId },
    }
    }, {
      default: _withCtx(() => [
        _createTextVNode(" Customer: " + _toDisplayString(__props.customerName), 1)
      ]),
      _: 1
    }, 8, ["to"]),
    (!finalize.value)
      ? (_openBlock(), _createElementBlock("div", _hoisted_1, [
          _createElementVNode("h1", null, "Schedule Move out of Unit " + _toDisplayString(__props.unitName), 1),
          _createElementVNode("div", _hoisted_2, [
            _hoisted_3,
            _withDirectives(_createElementVNode("input", {
              "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((formFields.value.move_out.desired_move_out_date) = $event)),
              type: "date",
              disabled: !_unref(api_settings).allow_schedule_move_out
            }, null, 8, _hoisted_4), [
              [_vModelText, formFields.value.move_out.desired_move_out_date]
            ])
          ]),
          _createElementVNode("button", {
            class: "btn",
            onClick: scheduleMoveOut
          }, "Schedule move out"),
          _createVNode(_component_RouterLink, {
            to: {
        name: 'customer_detail_storedge',
        params: { id: __props.customerId, facilityId: __props.facilityId },
      }
          }, {
            default: _withCtx(() => [
              _hoisted_5
            ]),
            _: 1
          }, 8, ["to"])
        ]))
      : (_openBlock(), _createElementBlock("form", {
          key: 1,
          class: "large-width-centered",
          onSubmit: _withModifiers(submitForm, ["prevent"])
        }, [
          _createElementVNode("h1", null, "Move out of Unit " + _toDisplayString(__props.unitName), 1),
          (finalizingToday.value)
            ? (_openBlock(), _createBlock(_component_BaseAlert, {
                key: 0,
                variant: "info"
              }, {
                default: _withCtx(() => [
                  _hoisted_7
                ]),
                _: 1
              }))
            : _createCommentVNode("", true),
          (_unref(api_settings).require_move_out_info)
            ? (_openBlock(), _createElementBlock(_Fragment, { key: 1 }, [
                _createElementVNode("div", _hoisted_8, [
                  _hoisted_9,
                  _withDirectives(_createElementVNode("select", {
                    "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((formFieldsStatus.value.unit.rentable) = $event)),
                    class: "form-select"
                  }, _hoisted_12, 512), [
                    [_vModelSelect, formFieldsStatus.value.unit.rentable]
                  ]),
                  _createElementVNode("small", null, "Select what you would like the status of Unit " + _toDisplayString(__props.unitName) + " to be after this move out is complete.", 1)
                ]),
                _createElementVNode("div", _hoisted_13, [
                  _hoisted_14,
                  _withDirectives(_createElementVNode("select", {
                    "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((formFields.value.payment_method.payment_method_id) = $event)),
                    class: "form-select",
                    onChange: _cache[3] || (_cache[3] = ($event: any) => (
            paymentMethod.value = paymentAccounts.value.filter(
              (item) => item.id == formFields.value.payment_method.payment_method_id
            )[0]
          ))
                  }, [
                    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(paymentAccounts.value, (account) => {
                      return (_openBlock(), _createElementBlock("option", {
                        key: account.id + 'account',
                        value: account.id
                      }, _toDisplayString(account.kind) + " " + _toDisplayString(account.card_number) + " " + _toDisplayString(account.account_type) + " " + _toDisplayString(account.account_number), 9, _hoisted_15))
                    }), 128))
                  ], 544), [
                    [_vModelSelect, formFields.value.payment_method.payment_method_id]
                  ])
                ]),
                _createElementVNode("div", _hoisted_16, [
                  _hoisted_17,
                  _withDirectives(_createElementVNode("input", {
                    "onUpdate:modelValue": _cache[4] || (_cache[4] = ($event: any) => ((formFields.value.refund.refund_check_name) = $event)),
                    type: "text"
                  }, null, 512), [
                    [_vModelText, formFields.value.refund.refund_check_name]
                  ])
                ]),
                _createElementVNode("div", _hoisted_18, [
                  _hoisted_19,
                  _withDirectives(_createElementVNode("input", {
                    "onUpdate:modelValue": _cache[5] || (_cache[5] = ($event: any) => ((formFields.value.refund.refund_check_address_attributes.address1) = $event)),
                    type: "text"
                  }, null, 512), [
                    [_vModelText, formFields.value.refund.refund_check_address_attributes.address1]
                  ])
                ]),
                _createElementVNode("div", _hoisted_20, [
                  _hoisted_21,
                  _withDirectives(_createElementVNode("input", {
                    "onUpdate:modelValue": _cache[6] || (_cache[6] = ($event: any) => ((formFields.value.refund.refund_check_address_attributes.address2) = $event)),
                    type: "text"
                  }, null, 512), [
                    [_vModelText, formFields.value.refund.refund_check_address_attributes.address2]
                  ])
                ]),
                _createElementVNode("div", _hoisted_22, [
                  _hoisted_23,
                  _withDirectives(_createElementVNode("input", {
                    "onUpdate:modelValue": _cache[7] || (_cache[7] = ($event: any) => ((formFields.value.refund.refund_check_address_attributes.city) = $event)),
                    type: "text"
                  }, null, 512), [
                    [_vModelText, formFields.value.refund.refund_check_address_attributes.city]
                  ])
                ]),
                _createElementVNode("div", _hoisted_24, [
                  _hoisted_25,
                  _withDirectives(_createElementVNode("input", {
                    "onUpdate:modelValue": _cache[8] || (_cache[8] = ($event: any) => ((formFields.value.refund.refund_check_address_attributes.state) = $event)),
                    type: "text"
                  }, null, 512), [
                    [_vModelText, formFields.value.refund.refund_check_address_attributes.state]
                  ])
                ]),
                _createElementVNode("div", _hoisted_26, [
                  _hoisted_27,
                  _withDirectives(_createElementVNode("input", {
                    "onUpdate:modelValue": _cache[9] || (_cache[9] = ($event: any) => ((formFields.value.refund.refund_check_address_attributes.postal) = $event)),
                    type: "text"
                  }, null, 512), [
                    [_vModelText, formFields.value.refund.refund_check_address_attributes.postal]
                  ])
                ]),
                _createElementVNode("div", _hoisted_28, [
                  _hoisted_29,
                  _withDirectives(_createElementVNode("input", {
                    "onUpdate:modelValue": _cache[10] || (_cache[10] = ($event: any) => ((formFields.value.refund.refund_check_address_attributes.country) = $event)),
                    type: "text"
                  }, null, 512), [
                    [_vModelText, formFields.value.refund.refund_check_address_attributes.country]
                  ])
                ]),
                _createElementVNode("div", _hoisted_30, [
                  _withDirectives(_createElementVNode("input", {
                    "onUpdate:modelValue": _cache[11] || (_cache[11] = ($event: any) => ((formFields.value.move_out.refund_security_deposit) = $event)),
                    type: "checkbox"
                  }, null, 512), [
                    [_vModelCheckbox, formFields.value.move_out.refund_security_deposit]
                  ]),
                  _hoisted_31
                ]),
                _createElementVNode("div", _hoisted_32, [
                  _withDirectives(_createElementVNode("input", {
                    "onUpdate:modelValue": _cache[12] || (_cache[12] = ($event: any) => ((formFields.value.move_out.refund_prepayment) = $event)),
                    type: "checkbox"
                  }, null, 512), [
                    [_vModelCheckbox, formFields.value.move_out.refund_prepayment]
                  ]),
                  _hoisted_33
                ])
              ], 64))
            : _createCommentVNode("", true),
          _createElementVNode("div", _hoisted_34, [
            _createElementVNode("button", {
              disabled: formSubmitting.value,
              type: "submit",
              class: "btn text-center"
            }, [
              (formSubmitting.value)
                ? (_openBlock(), _createElementBlock("div", _hoisted_36, [
                    _hoisted_37,
                    _createVNode(BaseSpinner)
                  ]))
                : (_openBlock(), _createElementBlock("div", _hoisted_38, "Finalize Move Out"))
            ], 8, _hoisted_35),
            _createVNode(_component_RouterLink, {
              to: {
          name: 'customer_detail_storedge',
          params: { id: __props.customerId, facilityId: __props.facilityId },
        }
            }, {
              default: _withCtx(() => [
                _hoisted_39
              ]),
              _: 1
            }, 8, ["to"])
          ])
        ], 40, _hoisted_6)),
    (formErrors.value.server_error !== undefined)
      ? (_openBlock(), _createBlock(_component_BaseAlert, {
          key: 2,
          variant: "danger",
          class: "js-form-error",
          dismissible: "",
          onDismissed: _cache[13] || (_cache[13] = ($event: any) => (formErrors.value = {}))
        }, {
          default: _withCtx(() => [
            _createTextVNode(_toDisplayString(formErrors.value.server_error[0]), 1)
          ]),
          _: 1
        }))
      : _createCommentVNode("", true)
  ], 64))
}
}

})